
export const environment = {
  production: true,
  baseUrl: 'https://api.seetukohlihome.com/api',
  imageUrl: 'https://api.seetukohlihome.com/api/media/image-resize',
  productUrl: 'https://api.seetukohlihome.com/',
  pluginUrl: 'https://api.seetukohlihome.com/'

};
